/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Zotero_ConnectInputs */

const en_settings_integrations_zotero_connect = /** @type {(inputs: Settings_Integrations_Zotero_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Zotero`)
};

const es_settings_integrations_zotero_connect = /** @type {(inputs: Settings_Integrations_Zotero_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar Zotero`)
};

/**
* | output |
* | --- |
* | "Connect Zotero" |
*
* @param {Settings_Integrations_Zotero_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_connect = /** @type {((inputs?: Settings_Integrations_Zotero_ConnectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_ConnectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_connect(inputs)
	return en_settings_integrations_zotero_connect(inputs)
});